import { startOfWeek, addDays, format, subWeeks } from 'date-fns';
import { es } from 'date-fns/locale';

export const useWeeklyData = (weekOffset: number, routines: any[], routineProgress: any[]) => {
  const startOfCurrentWeek = startOfWeek(subWeeks(new Date(), weekOffset), { weekStartsOn: 1 });

  console.log('Weekly data calculation:', {
    weekOffset,
    routinesCount: routines?.length,
    progressCount: routineProgress?.length,
    routineProgress
  });

  const weekDays = Array.from({ length: 7 }, (_, i) => {
    const date = addDays(startOfCurrentWeek, i);
    const dayProgress = routineProgress?.filter(progress => 
      format(new Date(progress.completed_at), 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd')
    );

    console.log(`Progress for ${format(date, 'EEE', { locale: es })}:`, {
      date: format(date, 'yyyy-MM-dd'),
      progressCount: dayProgress?.length,
      progressDetails: dayProgress
    });

    return {
      name: format(date, 'EEE', { locale: es }).toUpperCase(),
      date: format(date, 'yyyy-MM-dd'),
      count: dayProgress?.length || 0,
      routineNames: [] as string[],
      completedRoutines: [] as string[],
      goal: 0,
      isRestDay: true,
    };
  });

  // Assign routines to corresponding days and track completions
  routines?.forEach((routine) => {
    if (routine.routine_days && routine.routine_days.length > 0) {
      routine.routine_days.forEach((routineDay: any) => {
        const dayIndex = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].indexOf(routineDay.day);
        if (dayIndex !== -1) {
          weekDays[dayIndex].goal += 1;
          weekDays[dayIndex].isRestDay = false;
          if (!weekDays[dayIndex].routineNames.includes(routine.name)) {
            weekDays[dayIndex].routineNames.push(routine.name);
            
            // Check if this routine was completed on this day
            const wasCompleted = routineProgress?.some(progress => 
              progress.routine?.id === routine.id && 
              format(new Date(progress.completed_at), 'yyyy-MM-dd') === weekDays[dayIndex].date
            );
            
            if (wasCompleted) {
              console.log(`Routine ${routine.name} was completed on ${weekDays[dayIndex].date}`);
              weekDays[dayIndex].completedRoutines.push(routine.name);
            }
          }
        }
      });
    }
  });

  // Calculate total routines and progress
  const totalAssignedRoutines = weekDays.reduce((sum, day) => sum + day.goal, 0);
  const totalCompletedRoutines = weekDays.reduce((sum, day) => sum + day.count, 0);
  const progressPercentage = totalAssignedRoutines > 0 
    ? Math.round((totalCompletedRoutines / totalAssignedRoutines) * 100) 
    : 0;

  console.log('Progress calculation:', {
    totalAssignedRoutines,
    totalCompletedRoutines,
    progressPercentage,
    weekDaysDetails: weekDays.map(day => ({
      date: day.date,
      goal: day.goal,
      completed: day.count,
      routines: day.routineNames,
      completedRoutines: day.completedRoutines
    }))
  });

  return {
    weekDays,
    totalAssignedRoutines,
    totalCompletedRoutines,
    progressPercentage,
    startOfCurrentWeek
  };
};